<template lang="pug">
  .settings
      v-container.white.pa-0(style="max-width:600px")

        v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mt-5'")
          //- User setting
          .user_setting
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/user-access')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="person-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('user_settings') }}
                  .c1.basic600--text {{ $t('user_settings_description') }}
            v-divider.basic300
          //- Assign Table
          .assign_table
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/assign-table')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="inbox-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('assign_table') }}
                  .c1.basic600--text {{ $t('assign_table_description') }}
            v-divider.basic300
          //- Payment Settings
          .payment_settings
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/payment-settings')" style="cursor: pointer")
              v-col.shrink()
                v-icon.ma-auto(size="24" color="basic700") $yzi-coins-hand
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('payment_settings') }}
                  .c1.basic600--text {{ $t('payment_settings_description') }}
            v-divider.basic300
          //- Transaction History
          .transaction_history
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/transactions')" style="cursor: pointer")
              v-col.shrink()
                v-icon.ma-auto(size="24" color="basic700") $yzi-book-closed
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('transaction_history') }}
                  .c1.basic600--text {{ $t('history_of_payment') }}
            v-divider.basic300
          //- Receipt Template
          .receipt_template
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/receipt-template')" style="cursor: pointer")
              v-col.shrink()
                v-icon.ma-auto(size="24" color="basic700") $yzi-receipt
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('receipt_template') }}
                  .c1.basic600--text {{ $t('receipt_template_description') }}
            v-divider.basic300
          //- Hardware Settings
          .hardware_settings
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/hardware-settings')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="settings-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('hardware_settings') }}
                  .c1.basic600--text {{ $t('hardware_settings_description') }}
            v-divider.basic300

</template>

<script>
import { mapState } from 'vuex'
import DeleteCompany from '@/components/dialogs/settings/DeleteCompany.vue'

export default {
  name: 'PosSetup',
  components: { DeleteCompany },
  props: ['company'],
  data () {
    return {
      showSubscribeModal: false,
      deleteCompanyDialog: false,
    }
  },
  computed: {
    ...mapState('user', ['member'])
  }
}
</script>
